<script lang="ts">
  import { Faq } from '@squareup/public-web-design-system';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { FaqModuleProps } from './types';

  const { entryId, customCssClass, colorMode, heading, options, items, schema }: FaqModuleProps = $props();

  function handleClick(index: number): void {
    window.Sq.Tracking.track(
      {
        action: 'Content Explorer',
        properties: {
          question: items[index].question,
        },
      },
      { destinations: ['cdp'] }
    );
  }
</script>

<!-- JSON-LD can be placed anywhere in the HTML document and will be processed correctly. It does not have to be in the
 <head> element anymore -->
{@html schema}

<Faq
  class="FaqModule {customCssClass}"
  data-entry-id={entryId}
  {colorMode}
  headingText={heading}
  isFirstItemOpen={options.isFirstItemOpen}
  onClick={(index) => handleClick(index)}
  {items}
>
  {#snippet content({ answer })}
    <div class="RichTextFieldComponent">
      <DynamicChildrenComponent children={[answer]} />
    </div>
  {/snippet}
</Faq>
